import apiService from '../apiService';

// The community API reads the EDX tenant sync job and returns it as { data }.
// A tenant with no job is { data: null }, which is an incomplete sync.
export const userSyncAPI = apiService.injectEndpoints({
  endpoints: (builder) => ({
    getUserSyncJob: builder.query({
      query: () => ({
        url: 'tenants/v1/edfisync',
      }),
    }),
  }),
});

export const { useGetUserSyncJobQuery } = userSyncAPI;
